import { render, staticRenderFns } from "./orderMountings.vue?vue&type=template&id=3d202480&scoped=true"
import script from "./orderMountings.vue?vue&type=script&lang=js"
export * from "./orderMountings.vue?vue&type=script&lang=js"
import style0 from "./orderMountings.vue?vue&type=style&index=0&id=3d202480&prod&scoped=true&lang=scss"
import style1 from "./orderMountings.vue?vue&type=style&index=1&id=3d202480&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d202480",
  null
  
)

export default component.exports